import React from "react";
import cns from "classnames";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import locale from "@bonliva-crm/locale";
import { ThemeType } from "@theme";

import SecondaryButton from "@components/buttons/SecondaryButton";
import WithPopover from "@components/WithPopover";
import Body from "@components/typography/Body";
import { makeStyles } from "@material-ui/core/styles";

export type ActionBarButton = {
  disabled?: boolean;
  loading?: boolean;
  loadingContent?: boolean;
  icon?: JSX.Element;
  onClick?: () => any;
  title: string;
  tooltip?: string;
  ButtonProps?: Partial<React.ComponentProps<typeof SecondaryButton>>;
};

type Props = {
  buttons: ActionBarButton[];
  className?: string;
  onlyMyDisabled?: boolean;
  onlyMy?: boolean;
  onOnlyMy: (value: boolean) => any;
  workRequestMailing?: boolean;
  onWorkRequestMailing?: (event, checked) => void;
  campaign?: boolean;
  onCampaign?: (event, checked) => void;
};

export function ActionBar(props: Props) {
  const classes = useStyles({});
  return (
    <div className={cns(classes.root, props.className)} data-test="ActionBar">
      <div className={classes.wrapper}>
        {props.buttons.map((btn) => {
          const { tooltip } = btn;

          const btnNode = (
            <SecondaryButton
              key={btn.title}
              onClick={btn.onClick}
              leftIcon={btn.icon}
              disabled={btn.disabled}
              loading={btn.loading}
              loadingContent={btn.loadingContent}
              size="small"
              iconSize="small"
              variant="text"
              data-test="ActionBarButton"
              {...btn.ButtonProps}
            >
              {btn.title}
            </SecondaryButton>
          );

          return (
            <WithPopover
              key={btn.title}
              popoverContent={<Body color="error">{tooltip}</Body>}
              in={Boolean(tooltip)}
              PopoverProps={{
                anchorOrigin: { horizontal: "center", vertical: "bottom" }
              }}
            >
              {btnNode}
            </WithPopover>
          );
        })}

        <FormControlLabel
          control={
            <Checkbox
              checked={props.workRequestMailing}
              onChange={props.onWorkRequestMailing}
            />
          }
          label={locale.ApprovedMailing}
        />

        {props.onCampaign && (
          <FormControlLabel
            control={
              <Checkbox checked={props.campaign} onChange={props.onCampaign} />
            }
            label={locale.SendAsCampaign}
          />
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    padding: theme.spacing()
  },

  wrapper: {
    ...theme.mixins.childrenMarginRight(theme.spacing()),
    alignItems: "center",
    display: "flex",

    "& svg": {
      fontSize: 18,
      height: "1em",
      width: "1em"
    }
  }
}));
